var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSavePercentArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0533 0H2.0784C0.640607 0 0.64046 26 2.0784 26H17.0533C18.469 26 19.7732 25.2516 20.4925 24.0322L25.8013 15.0322C26.5409 13.7784 26.5409 12.2216 25.8013 10.9678L20.4925 1.96776C19.7732 0.748358 18.469 0 17.0533 0ZM13.0001 17C15.2092 17 17.0001 15.2091 17.0001 13C17.0001 10.7909 15.2092 9 13.0001 9C10.7909 9 9.00008 10.7909 9.00008 13C9.00008 15.2091 10.7909 17 13.0001 17Z",
    fill: "#FFC227"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 26,
    fill: "#FFC227"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavePercentArrow);
export default __webpack_public_path__ + "static/media/save-percent-arrow.b4a77311.svg";
export { ForwardRef as ReactComponent };